import React, { useContext } from 'react';
import Button from 'atomic/button';
import WidgetPhotosGridAdvancedProps from './widget-photos-grid-advanced.props';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import classNames from 'classnames';
import Icon from 'atomic/icon';

import './widget-photos-grid-advanced.scss';

const WidgetPhotosGridAdvanced: React.FC<WidgetPhotosGridAdvancedProps> = ({ data, config }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className="w-photos-grid-advanced">
            <div className="w-photos-grid-advanced__list">
                {data.map((item, idx, arr) => (
                    <div
                        key={item.url}
                        className={classNames({
                            'w-photos-grid-advanced__list__item': true,
                            'w-photos-grid-advanced__list__item--desktop': api.getDevice() === 'desktop',
                            'w-photos-grid-advanced__list__item--small': idx !== 0 && arr.length - 1 !== idx,
                            'w-photos-grid-advanced__list__item--big': idx === 0,
                            'w-photos-grid-advanced__list__item--medium': idx === 7
                        })}
                    >
                        <a
                            target={item.target}
                            href={item.url}
                        >
                            <picture>
                                <img src={item.img} alt={item.title} loading="lazy" />
                            </picture>
                            <div
                                className={classNames({
                                    'title-box': true,
                                    'title-box--desktop': api.getDevice() === 'desktop',
                                    'title-box--small': idx !== 0 && arr.length - 1 !== idx,
                                    'title-box--big': idx === 0,
                                    'title-box--medium': arr.length - 1 === idx
                                })}
                            >
                                <h2 className="title-box__title" style={{ color: config?.styles?.text.color }}>
                                    {item.title}
                                </h2>
                                {(idx === 0 && api.getDevice() === 'desktop' && config?.buttonFirst?.text) && (
                                    <Button
                                        style={{
                                            color: config?.buttonFirst?.styles?.color,
                                            backgroundColor: config?.buttonFirst?.styles?.background,
                                            backgroundImage: `linear-gradient(to bottom, ${config?.buttonFirst?.styles?.background}, 
                                            ${config?.buttonFirst?.styles?.background})`
                                        }}
                                        color="primary"
                                        size={config?.buttonFirst?.styles?.size || 'md'}
                                    >
                                        {config?.buttonFirst?.text}
                                        {' '}
                                        <Icon name="arrow-right" size={16} />
                                    </Button>
                                )}
                                {(arr.length - 1 === idx && api.getDevice() === 'desktop' && config?.buttonSecond?.text) && (
                                    <Button
                                        style={{
                                            color: config?.buttonSecond?.styles?.color,
                                            backgroundColor: config?.buttonSecond?.styles?.background,
                                            backgroundImage: `linear-gradient(to bottom, ${config?.buttonSecond?.styles?.background}, 
                                            ${config?.buttonSecond?.styles?.background})`
                                        }}
                                        color="primary"
                                        uppercase={true}
                                        size={config?.buttonSecond?.styles?.size || 'md'}
                                    >
                                        {config?.buttonSecond?.text}
                                        {' '}
                                        <Icon name="arrow-right" size={16} />
                                    </Button>
                                )}
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WidgetPhotosGridAdvanced;
